// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"2533db2deda271efd941","293":"0a35404708cfd7c1f076","518":"498ca27a8a0b52a7eb0e","779":"aade875d8b4bda75e283"}[chunkId] + ".js";
};